/**
 * @generated SignedSource<<56b8d5cf36ebedae4ce119955c7854f5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageDateAddFlightDialog_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FlightSearchForm_data">;
  readonly " $fragmentType": "PackageDateAddFlightDialog_data";
};
export type PackageDateAddFlightDialog_data$key = {
  readonly " $data"?: PackageDateAddFlightDialog_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateAddFlightDialog_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageDateAddFlightDialog_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FlightSearchForm_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "63f1722d9ff795ad1ce4d0b6f065ed12";

export default node;
